import DocumentArrow from './DocumentArrow';

export default DocumentArrow;
